import React from 'react';
import { LocalizedLink } from '../../primitives';



export default function Logo(props: { logoSrc: string }) {
    return (
        <div className='logoWrap'>
            <LocalizedLink to='/'>
                <img alt='Logo' src={props.logoSrc} />
            </LocalizedLink>
        </div>
    );
}
